module.exports = __webpack_public_path__ + "img/Lumina.e42a6ee9.png";